interface Prefecture {
    iso: string,
    prefecture_kanji: string,
    prefecture_romaji: string,
    prefecture_kana: string,
}

export const Prefectures:Prefecture[] = [
    {
        "iso": "01",
        "prefecture_kanji": "北海道",
        "prefecture_romaji": "Hokkaido",
        "prefecture_kana": "ほっかいどう"
    },
    {
        "iso": "02",
        "prefecture_kanji": "青森県",
        "prefecture_romaji": "Aomori Ken",
        "prefecture_kana": "あおもりけん"
    },
    {
        "iso": "03",
        "prefecture_kanji": "岩手県",
        "prefecture_romaji": "Iwate Ken",
        "prefecture_kana": "いわてけん"
    },
    {
        "iso": "04",
        "prefecture_kanji": "宮城県",
        "prefecture_romaji": "Miyagi Ken",
        "prefecture_kana": "みやぎけん"
    },
    {
        "iso": "05",
        "prefecture_kanji": "秋田県",
        "prefecture_romaji": "Akita Ken",
        "prefecture_kana": "あきたけん"
    },
    {
        "iso": "06",
        "prefecture_kanji": "山形県",
        "prefecture_romaji": "Yamagata Ken",
        "prefecture_kana": "やまがたけん"
    },
    {
        "iso": "07",
        "prefecture_kanji": "福島県",
        "prefecture_romaji": "Fukushima Ken",
        "prefecture_kana": "ふくしまけん"
    },
    {
        "iso": "08",
        "prefecture_kanji": "茨城県",
        "prefecture_romaji": "Ibaraki Ken",
        "prefecture_kana": "いばらきけん"
    },
    {
        "iso": "09",
        "prefecture_kanji": "栃木県",
        "prefecture_romaji": "Tochigi Ken",
        "prefecture_kana": "とちぎけん"
    },
    {
        "iso": "10",
        "prefecture_kanji": "群馬県",
        "prefecture_romaji": "Gunma Ken",
        "prefecture_kana": "ぐんまけん"
    },
    {
        "iso": "11",
        "prefecture_kanji": "埼玉県",
        "prefecture_romaji": "Saitama Ken",
        "prefecture_kana": "さいたまけん"
    },
    {
        "iso": "12",
        "prefecture_kanji": "千葉県",
        "prefecture_romaji": "Chiba Ken",
        "prefecture_kana": "ちばけん"
    },
    {
        "iso": "13",
        "prefecture_kanji": "東京都",
        "prefecture_romaji": "Tokyo To",
        "prefecture_kana": "とうきょうと"
    },
    {
        "iso": "14",
        "prefecture_kanji": "神奈川県",
        "prefecture_romaji": "Kanagawa Ken",
        "prefecture_kana": "かながわけん"
    },
    {
        "iso": "15",
        "prefecture_kanji": "新潟県",
        "prefecture_romaji": "Niigata Ken",
        "prefecture_kana": "にいがたけん"
    },
    {
        "iso": "16",
        "prefecture_kanji": "富山県",
        "prefecture_romaji": "Toyama Ken",
        "prefecture_kana": "とやまけん"
    },
    {
        "iso": "17",
        "prefecture_kanji": "石川県",
        "prefecture_romaji": "Ishikawa Ken",
        "prefecture_kana": "いしかわけん"
    },
    {
        "iso": "18",
        "prefecture_kanji": "福井県",
        "prefecture_romaji": "Fukui Ken",
        "prefecture_kana": "ふくいけん"
    },
    {
        "iso": "19",
        "prefecture_kanji": "山梨県",
        "prefecture_romaji": "Yamanashi Ken",
        "prefecture_kana": "やまなしけん"
    },
    {
        "iso": "20",
        "prefecture_kanji": "長野県",
        "prefecture_romaji": "Nagano Ken",
        "prefecture_kana": "ながのけん"
    },
    {
        "iso": "21",
        "prefecture_kanji": "岐阜県",
        "prefecture_romaji": "Gifu Ken",
        "prefecture_kana": "ぎふけん"
    },
    {
        "iso": "22",
        "prefecture_kanji": "静岡県",
        "prefecture_romaji": "Shizuoka Ken",
        "prefecture_kana": "しずおかけん"
    },
    {
        "iso": "23",
        "prefecture_kanji": "愛知県",
        "prefecture_romaji": "Aichi Ken",
        "prefecture_kana": "あいちけん"
    },
    {
        "iso": "24",
        "prefecture_kanji": "三重県",
        "prefecture_romaji": "Mie Ken",
        "prefecture_kana": "みえけん"
    },
    {
        "iso": "25",
        "prefecture_kanji": "滋賀県",
        "prefecture_romaji": "Shiga Ken",
        "prefecture_kana": "しがけん"
    },
    {
        "iso": "26",
        "prefecture_kanji": "京都府",
        "prefecture_romaji": "Kyoto Fu",
        "prefecture_kana": "きょうとふ"
    },
    {
        "iso": "27",
        "prefecture_kanji": "大阪府",
        "prefecture_romaji": "Osaka Fu",
        "prefecture_kana": "おおさかふ"
    },
    {
        "iso": "28",
        "prefecture_kanji": "兵庫県",
        "prefecture_romaji": "Hyōgo Ken",
        "prefecture_kana": "ひょうごけん"
    },
    {
        "iso": "29",
        "prefecture_kanji": "奈良県",
        "prefecture_romaji": "Nara Ken",
        "prefecture_kana": "ならけん"
    },
    {
        "iso": "30",
        "prefecture_kanji": "和歌山県",
        "prefecture_romaji": "Wakayama Ken",
        "prefecture_kana": "わかやまけん"
    },
    {
        "iso": "31",
        "prefecture_kanji": "鳥取県",
        "prefecture_romaji": "Tottori Ken",
        "prefecture_kana": "とっとりけん"
    },
    {
        "iso": "32",
        "prefecture_kanji": "島根県",
        "prefecture_romaji": "Shimane Ken",
        "prefecture_kana": "しまねけん"
    },
    {
        "iso": "33",
        "prefecture_kanji": "岡山県",
        "prefecture_romaji": "Okayama Ken",
        "prefecture_kana": "おかやまけん"
    },
    {
        "iso": "34",
        "prefecture_kanji": "広島県",
        "prefecture_romaji": "Hiroshima Ken",
        "prefecture_kana": "ひろしまけん"
    },
    {
        "iso": "35",
        "prefecture_kanji": "山口県",
        "prefecture_romaji": "Yamaguchi Ken",
        "prefecture_kana": "やまぐちけん"
    },
    {
        "iso": "36",
        "prefecture_kanji": "徳島県",
        "prefecture_romaji": "Tokushima Ken",
        "prefecture_kana": "とくしまけん"
    },
    {
        "iso": "37",
        "prefecture_kanji": "香川県",
        "prefecture_romaji": "Kagawa Ken",
        "prefecture_kana": "かがわけん"
    },
    {
        "iso": "38",
        "prefecture_kanji": "愛媛県",
        "prefecture_romaji": "Ehime Ken",
        "prefecture_kana": "えひめけん"
    },
    {
        "iso": "39",
        "prefecture_kanji": "高知県",
        "prefecture_romaji": "Kōchi Ken",
        "prefecture_kana": "こうちけん"
    },
    {
        "iso": "40",
        "prefecture_kanji": "福岡県",
        "prefecture_romaji": "Fukuoka Ken",
        "prefecture_kana": "ふくおかけん"
    },
    {
        "iso": "41",
        "prefecture_kanji": "佐賀県",
        "prefecture_romaji": "Saga Ken",
        "prefecture_kana": "さがけん"
    },
    {
        "iso": "42",
        "prefecture_kanji": "長崎県",
        "prefecture_romaji": "Nagasaki Ken",
        "prefecture_kana": "ながさきけん"
    },
    {
        "iso": "43",
        "prefecture_kanji": "熊本県",
        "prefecture_romaji": "Kumamoto Ken",
        "prefecture_kana": "くまもとけん"
    },
    {
        "iso": "44",
        "prefecture_kanji": "大分県",
        "prefecture_romaji": "Ōita Ken",
        "prefecture_kana": "おおいたけん"
    },
    {
        "iso": "45",
        "prefecture_kanji": "宮崎県",
        "prefecture_romaji": "Miyazaki Ken",
        "prefecture_kana": "みやざきけん"
    },
    {
        "iso": "46",
        "prefecture_kanji": "鹿児島県",
        "prefecture_romaji": "Kagoshima Ken",
        "prefecture_kana": "かごしまけん"
    },
    {
        "iso": "47",
        "prefecture_kanji": "沖縄県",
        "prefecture_romaji": "Okinawa Ken",
        "prefecture_kana": "おきなわけん"
    }
]